export function DefaultChangeValueRenderer({ value }: { value: string }) {
  return <span className="text-sm">{value || 'None'}</span>;
}
